
import { Vue, Component } from 'vue-property-decorator';
import { schools } from '../utils/schools';
@Component
export default class ShowCollege extends Vue {
  currItem = '';
  objArr: any[] = schools;

  choose(items: any) {
    this.currItem = items.name;
    this.$router.push(
      `/chuan-mei-liu-yue/ShowCollegeDetail?name=${this.currItem}`,
    );
  }
}
